import { useEffect } from 'react';
import { Head, Link } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { route } from '../../utils/route';
import { dataLayerPushAsync } from '../../utils/tracking';

interface WelcomeProps {
  hasFreeDelivery: boolean;
}

const TruckIcon = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="7" cy="17" r="2" />
    <circle cx="17" cy="17" r="2" />
    <path d="M5 17H3v-4M2 5h11v12M15 7h1a2 2 0 0 1 2 2v6h1" />
  </svg>
);

export default function Welcome({ hasFreeDelivery }: WelcomeProps) {
  // Evento estable para GTM (#95): la conversión de esta página dependía de
  // un selector de CSS que se rompía con cada cambio de diseño. Marketing
  // re-apunta el trigger de GTM a este evento.
  useEffect(() => {
    dataLayerPushAsync({ event: 'welcome_free_delivery_viewed', has_free_delivery: hasFreeDelivery });
  }, []);

  return (
    <MainLayout>
      <Head title="Bienvenido | Abasto Virtual">
        <meta name="robots" content="noindex" />
      </Head>

      <div className="flex min-h-[60vh] items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
          <img
            src="https://cdn.abastovirtual.com/img/logo.webp"
            alt="Logo de AbastoVirtual"
            className="mx-auto mb-6 w-48"
          />

          <h1 className="mb-4 text-2xl font-bold text-green-600">
            ¡Gracias por registrarte!
          </h1>

          <p className="mb-6 text-gray-600">
            Estamos emocionados de tenerte como parte de la familia AbastoVirtual.
          </p>

          {hasFreeDelivery && (
            <div className="mb-6 flex items-center justify-center gap-2 font-bold text-green-600">
              <TruckIcon className="h-6 w-6" />
              Tu primer pedido tiene envío gratis
            </div>
          )}

          <Link
            href={route('products.index')}
            className="inline-block rounded-xl bg-green-500 px-6 py-3 font-bold text-white transition-colors hover:bg-green-600"
          >
            Ir a la tienda
          </Link>
        </div>
      </div>
    </MainLayout>
  );
}
